export enum CargoTypeCodeEnum {
  ADR_LQ = 'ADR_LQ',
  COMMON_GOODS = 'COMMON_GOODS',
}
